import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import storage from '@/utils/storage'
const proto = Vue.prototype

Vue.use(Router)

const router = new Router({
  base:'freeroom',
  mode: 'history',
  routes: [
    {
      path: '/room/booking',
      name: 'RoomBook',
      component: () => import('@/pages/Booking/Result'),
      meta: {
        menu: 'bookingMenu',
        class: 'booking result'
      }
    },
    {
      path: '/room/booking/edit/:id',
      name: 'RoomBook',
      component: () => import('@/pages/Booking/Edit'),
      props: true
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/SignIn/Login'),
      meta: {
        fullScreen: true,
        disableAuth: true
      }
    },
    {
      path: '/signin',
      name: 'SignIn',
      component: () => import('@/pages/SignIn/Signin'),
      meta: {
        fullScreen: true,
        disableAuth: true
      }
    },
    {
      path: '/room/booking/now',
      name: 'RoomBookNow',
      component: () => import('@/pages/Building/Building')
    },
    {
      path: '/admin/protect',
      name: 'ProtectReservation',
      component: () => import('@/pages/ProtectReservation/ProtectReservation'),
      meta: {
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/approval',
      name: 'ApprovalReservation',
      component: () => import('@/pages/ApprovalReservation/ApprovalReservation'),
      meta: {
        showBookingApprover: true,
        roles:{
          client: true,
          approver: true,
        }
      }
    },
    {
      path: '/admin/service',
      name: 'ServiceRequests',
      component: () => import('@/pages/ServiceDesk/ServiceDesk'),
      meta: {
        showServiceDesk: true,
        roles:{
          client: true,
          service: true,
        }
      }
    },
    {
      path: '/admin/dashboards/monitoring',
      name: 'DashboardMonitoringReport',
      component: () => import('@/pages/Reports/DashboardMonitoringReport'),
      meta: {
        features: {
          hasMonitoring: true
        },
        roles:{
          client: true,
          reports: true
        }
      },
    },
    {
      path: '/admin/dashboards/rooms',
      name: 'DashboardRoomReport',
      component: () => import('@/pages/Reports/DashboardRoomReport'),
      meta: {
        features: {
          hasMonitoring: true
        },
        roles:{
          client: true,
          reports: true
        }
      }
    },
    {
      path: '/admin/reports/roomEvent',
      name: 'RoomEventReport',
      component: () => import('@/pages/Reports/RoomEventReport'),
      meta: {
        features: {
          hasMonitoring: true
        },
        roles:{
          client: true,
          reports: true
        }
      }
    },
    {
      path: '/admin/clients/edit/calendar/provider',
      name: 'CalendarConfiguration',
      component: () => import('@/pages/Manager/Clients/ClientCalendarConfiguration'),
      meta: {
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/global/clients/edit/equipment',
      name: 'EditEquipment',
      component: () => import('@/pages/Manager/Clients/ClientEquipmentGlobalConfiguration'),
      meta: {
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/clients/edit/equipment',
      name: 'EditEquipment',
      component: () => import('@/pages/Manager/Clients/ClientEquipmentsConfiguration'),
      meta: {
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/clients/edit/device',
      name: 'EditCalendar',
      component: () => import('@/pages/Manager/Clients/ClientDevices'),
      meta: {
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/clients/locations',
      name: 'Locations',
      component: () => import('@/pages/Manager/Locations/Locations'),
      meta: {
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/clients/location/rooms',
      name: 'Rooms',
      component: () => import('@/pages/Manager/Rooms/Rooms'),
      meta: {
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/clients/rooms/new',
      name: 'NewRoom',
      component: () => import('@/pages/Manager/Rooms/RoomGeneralConfiguration'),
      meta: {
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/clients/combinedRooms/new',
      name: 'NewCombinedRoom',
      component: () => import('@/pages/Manager/Rooms/CombinedRoomGeneralConfiguration'),
      meta: {
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/clients/location/:locationId/rooms/:roomId/edit/general',
      name: 'EditRoomGeneral',
      component: () => import('@/pages/Manager/Rooms/RoomGeneralConfiguration'),
      meta: {
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/clients/location/:locationId/combinedRooms/:roomId/edit/general',
      name: 'EditCombinedRoomGeneral',
      component: () => import('@/pages/Manager/Rooms/CombinedRoomGeneralConfiguration'),
      meta: {
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/clients/location/:locationId/rooms/:roomId/edit/device',
      name: 'EditRoomDevice',
      component: () => import('@/pages/Manager/Rooms/RoomDevicesConfiguration'),
      meta: {
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/clients/location/:locationId/rooms/:roomId/edit/behavior',
      name: 'EditRoomBehavior',
      component: () => import('@/pages/Manager/Rooms/RoomBehaviorConfiguration'),
      meta: {
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/clients/location/:locationId/combinedRooms/:roomId/edit/behavior',
      name: 'EditCombinedRoomBehavior',
      component: () => import('@/pages/Manager/Rooms/CombinedRoomBehaviorConfiguration'),
      meta: {
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/clients/supplier/',
      name: 'Supplier',
      component: () => import('@/pages/Manager/ServiceDesk/Supplier'),
      meta: {
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/clients/supplier/foods/',
      name: 'SupplierFoods',
      component: () => import('@/pages/Manager/ServiceDesk/SupplierItems'),
      meta: {
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/clients/supplier/equipments/',
      name: 'SupplierEquipments',
      component: () => import('@/pages/Manager/ServiceDesk/SupplierItems'),
      meta: {
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/*',
      name: 'Error',
      component: () => import('@/pages/Error/Error'),
      meta: {
        class: 'error'
      }
    }
  ]
})

const getClientAdminFromSession = async() => {
  let obj = {
    clientId: storage.getFromLocalStorage('clientIdFreeroom'),
    originalClientId: storage.getFromLocalStorage('originalFreeroomId')
  }

  const clientId = store.getters['Client/clientId']
  if(!clientId || (clientId !== obj.clientId)) {
    await store.dispatch('Client/setClientAdmin', obj, {root: true})
    await store.dispatch('Global/updateInitialSettings', null, {root: true})
  }
}

const checkAdminUrlAndInitialSettingsToNavigate = async (to, from, next) => {
  if (store.getters['Auth/isGlobalAdminHostname']) {
    await getClientAdminFromSession()
    if ((to.meta.globalAdminUrlOnly !== undefined && !to.meta.globalAdminUrlOnly) && !to.meta.disableAuth && store.getters['Client/originalClientId'] === null && to.path !== '/notFound') {
      next({path: '/'})
    }
  } else if (!store.getters['Auth/isGlobalAdminHostname']) {
    if (to.meta.globalAdminUrlOnly) {
      next({path: '/notFound'})
    }
  }

  if (!store.getters['Auth/isGlobalAdminHostname'] && to.path !== '/settingsInitial' && !isLoginPath(to)) {
    await checkInitialSettings(to, next)
  }

  next()
}

const checkAdminRole = (to) => {
  let isAllowed = false
  if(to.meta.roles){
      for(var roleInRoute in to.meta.roles){
        let available =  (store.getters['Auth/role'] && store.getters['Auth/role'].some( role => role === proto.$rolesFreeroom.rolesWithoutGroup[roleInRoute])) || store.getters['Auth/isGlobalAdmin']
        if(available){
          isAllowed = true
        }
      }
  }
  return isAllowed
}

const isRoleAllowed = (to) => {
  if(checkAdminRole(to)){
    return true
  }
  if (to.meta.showServiceDesk) {
    return (store.getters['Auth/isServiceDesk'] || store.getters['Auth/isAdmin']) && store.getters['Global/isServiceDeskEnabled']
  }
  if (to.meta.showBookingApprover) {
    return store.getters['Auth/isBookingApprover'] || store.getters['Auth/isAdmin']
  }
  if (to.meta.globalAdminUrlOnly) {
    if (store.getters['Auth/isGlobalAdmin']) {
      return true
    } else {
      return false
    }
  }
  if (to.path.includes('admin')) {
    if (store.getters['Auth/isAdmin']) {
      return true
    } else {
      return false
    }
  }
  return true
}

const checkRole = async (to, from, next) => {
  if (isRoleAllowed(to, from, next)) {
    checkAdminUrlAndInitialSettingsToNavigate(to, from, next)
  } else {
    next('notFound')
  }
}

const checkLoading = (to) => {
  if (to.meta.hideLoading) {
    store.dispatch('Global/hideLoading', null, {root: true})
  }
}

const checkInitialSettings = async (to, next) => {
  if (store.getters['Global/showSettings']) {
    next({path: '/settingsInitial'})
  }
}

const isLoginPath = (to) => {
  if (to.path === '/signin' || to.path === '/login') {
    return true
  }

  return false
}

router.beforeEach(async (to, from, next) => {
  if (store.getters['Auth/isAuthenticated']) {
    // already signed in, we can navigate anywhere
    await checkRole(to, from, next)
    checkLoading(to)
  } else if (!to.meta.disableAuth) {
    // authentication is required. Trigger the sign in process
    await store.dispatch('Auth/authenticate')
    if(store.getters['Auth/isAuthenticated']){
      await checkRole(to, from, next)
      checkLoading(to)
    } else {
      next({path: '/login'})
    }
  } else {
    // No auth required. We can navigate
    await checkRole(to, from, next)
    checkLoading(to)
  }
})

// eslint-disable-next-line no-unused-vars
router.afterEach(async (to, from) => {
  window.gtag('config', process.env.VUE_APP_GT_TAG, {
    'page_title': to.name,
    'page_path': to.path
  })
  window.cx.tracking('send', 'screen', to.name)
})

export default router
